export function GetDistanceBetweenRectAndCircle(rect, circle) {
    // find the closest point to the circle within the rectangle
    const closestX = circle.x.KeepBetween(rect.x, rect.Right);
    const closestY = circle.y.KeepBetween(rect.y, rect.Bottom);
    // calculate the distance between the circle's center and this closest point
    const distanceX = circle.x - closestX;
    const distanceY = circle.y - closestY;
    // if the distance is less than the circle's radius, an intersection occurs
    const distanceSquared = (distanceX * distanceX) + (distanceY * distanceY);
    //return distanceSquared < (circle.radius * circle.radius);
    return distanceSquared.ToPower(1 / 2);
}
export function GetDistanceBetweenRectAndPoint(rect, point) {
    return GetDistanceBetweenRectAndCircle(rect, { x: point.x, y: point.y, radius: 0 });
}
//# sourceMappingURL=Geometry.js.map